// extracted by mini-css-extract-plugin
export default {"productGallery":"SJ-z","inQuickShop":"TJ-z"};